const OurStory = () => {
  const sections = [
    {
      title: 'قصة نجاحنا',
      content: 'بدأت رحلتنا منذ أكثر من 15 عاماً بهدف واضح: توفير حلول أمنية متكاملة تحمي المنشآت والمشاريع الكبرى بأعلى معايير الجودة. نمت الشركة بفضل ثقة عملائنا وتفانينا في تقديم أفضل الخدمات، لنصبح اليوم من الشركات الرائدة في المملكة في مجال الأنظمة الأمنية.',
      image: 'https://public.readdy.ai/ai/img_res/304945f14f7b0d564728d4d21a3c0565.jpg',
      reverse: false,
    },
    {
      title: 'التزامنا بالتميز',
      content: 'نلتزم بتقديم أعلى مستويات الجودة في كل مشروع نقوم به. نستخدم أحدث التقنيات العالمية ونعمل مع أفضل الشركات المصنعة لضمان حصول عملائنا على أنظمة أمنية موثوقة وفعالة. فريقنا المحترف يخضع لتدريب مستمر لمواكبة أحدث التطورات في مجال الأمن والحماية.',
      image: 'https://readdy.ai/api/search-image?query=professional%20security%20technician%20installing%20advanced%20surveillance%20system%2C%20expert%20engineer%20working%20on%20high-tech%20security%20equipment%2C%20modern%20security%20installation%20work%2C%20professional%20uniform%20and%20safety%20gear%2C%20clean%20corporate%20work%20environment%2C%20technical%20expertise%20demonstration&width=700&height=600&seq=story-excellence-002&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <section className="py-24">
      {sections.map((section, index) => (
        <div
          key={index}
          className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-light/30'} py-16`}
        >
          <div className="container mx-auto px-6">
            <div className={`grid lg:grid-cols-2 gap-16 items-center ${section.reverse ? 'lg:flex-row-reverse' : ''}`}>
              {/* Image */}
              <div className={`${section.reverse ? 'lg:order-2' : ''}`}>
                <div className="rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src={section.image}
                    alt={section.title}
                    className="w-full h-[500px] object-cover"
                  />
                </div>
              </div>

              {/* Content */}
              <div className={`${section.reverse ? 'lg:order-1' : ''}`}>
                <h2 className="text-4xl font-bold text-navy-light mb-6">
                  {section.title}
                </h2>
                <p className="text-gray-dark text-lg leading-relaxed">
                  {section.content}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default OurStory;